export function CardSkeleton() {
  return (
    <div className="bg-card rounded-2xl border border-border overflow-hidden animate-pulse">
      <div className="w-full aspect-square bg-muted" />
      <div className="p-5 space-y-4">
        <div className="h-5 w-3/4 rounded bg-muted" />
        <div className="space-y-2">
          <div className="h-3 w-2/3 rounded bg-muted" />
          <div className="h-3 w-full rounded bg-muted" />
          <div className="h-3 w-1/2 rounded bg-muted" />
        </div>
      </div>
    </div>
  );
}
